export default function phoneFormatter(phone) {
    phone = phone.replace(/[^\d]/g, ""); 
    return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
}

// (11) 91234-5678 ou (11) 1234-5678; outro tamanho volta como veio.
export function formatPhone(number) {
    const cleaned = number.replace(/\D/g, '');

    if (cleaned.length === 10) {
        return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    if (cleaned.length === 11) {
        return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }

    return number
}
